// Dependencies
require("section/cta");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/cta/index.js
 ** module id = 162
 ** module chunks = 0 1
 **/